
import { defineComponent, ref, computed, watch, createApp } from 'vue';
import { GoogleMap, CustomMarker, InfoWindow, Marker } from "vue3-google-map";
import loadingAnimation from './loading-lottie.json';
import * as turf from '@turf/turf';
import { Vue3Lottie } from 'vue3-lottie';
import 'vue3-lottie/dist/style.css';
import InfoContent from './InfoContent.vue';
import BranchPane from './BranchPane';
import {debounce} from 'lodash-es';
import axios from 'axios';
const mapTheme = require('./map-theme.json');

export default {
    components: { GoogleMap, CustomMarker, InfoWindow, InfoContent, Vue3Lottie, Marker, BranchPane },

    data() {
        return {
            bounds: null,
            showLoading: true,
            center: {
                lat: 39.954631,
                lng: -82.8651341
            },
            unFiltered: [],
            activeInfoWindow: null,
            theme: mapTheme,
            filtersOpen: false,
            openedLocation: null,
            autocompleteService: null,
            autocompleteVisible: false,
            loadingAnimation: loadingAnimation,
            list:[],
            loctype: 'A',
            searchString: '',
            filter: ['S', 'A'],
            showAtms: true,
            showApiBranches: true,
            showCraftBranches: true,
            filtersOpen: false,
            geoLocationExists: true,
            locationErrorMessage: null,
            locationErrorShow: false,
            showSidebar: false, //mobile only
            showSidebarBranches: true,
            openedLocation: null,
            locale: 'en',
            atmMarkerSize:  null,
            branchMarkerSize:  null,
            markerOptimized: true,
            markerLabelPos: null,
            showBranchPane: false,
            branchSlug: '',
            branchesOnly: []
        }
    },

    watch: {
        filter(){
            //close info window when filter changes so we don't have info windows floating to hidden markers
            this.activeInfoWindow && this.activeInfoWindow.close();
        },

        showSidebar(){
            // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
            let vh = window.innerHeight * 0.01;
            // Then we set the value in the --vh custom property to the root of the document
            document.documentElement.style.setProperty('--vh', `${vh}px`);
        }
    },

    computed: {
        markers(){
            return this.unFiltered.filter((item)=>{
                return this.isVisible(item);
                /* if ( !this.showCraftBranches && item.properties.source == 'craft' )
                {
                    return false;
                } */


                // return this.filter.indexOf(item.properties.type) > -1
            });
        },
        collectionize(){
            //collect the markers in proper geoJSON format
            let customCollection = {
                type:'FeatureCollection',
                features:this.markers
            };

            //Filter the collection by branches/atm filter settings
            customCollection.features = customCollection.features.filter((item)=>{
                // return this.filter.indexOf(item.properties.type) > -1
                return this.isVisible(item);
            });

            return customCollection;
        },
        /**
         * Visible Markers
         * Determin which markers are currently in the viewport for rending of the list view
         */
        visibleMarkers() {
            if (!this.bounds || !this.markers.length){
                return []
            }

            var bounds = this.bounds.toJSON();
            var searchWithin = turf.polygon([[
                [bounds.west,bounds.north],
                [bounds.east,bounds.north],
                [bounds.east,bounds.south],
                [bounds.west,bounds.south],
                [bounds.west,bounds.north]
            ]]);

            var ptsWithin = turf.pointsWithinPolygon(this.collectionize, searchWithin);
            ptsWithin.features.filter(item => {
                // this.filter.indexOf(item.properties.type) > -1
                this.isVisible(item)
            });

            return ptsWithin.features;
        }
    },

    methods: {
        fetchMarkers: debounce(function(){
            // console.log( 'fetchMarkers()->debounce()', this.$refs.mapRef.map );
            this.bounds = this.$refs.mapRef.map.getBounds();
            var currentMapCenter = this.$refs.mapRef.map.getCenter();
            this.showLoading = true;
            axios.get('/actions/branch-finder/branch-finder/lat-lng-search',{
                params: {
                    lat: currentMapCenter.lat(),
                    long: currentMapCenter.lng(),
                },
                headers: {
                    'X-CSRF-Token': window.csrfToken
                }
            })
            .then( (response) => {
                // console.log('data response',response.data.geojson);
                this.addMarkers(response.data.results);
                this.showLoading = false;
            })
            .catch(function (error) {
                console.error(error);
                this.showLoading = false;
            });

            this.showLoading = true;

        }, 500),

        isVisible(marker)
        {
            var visible = false;

            if(marker == null)
            {
                return false;
            }

            if(marker.properties == null)
            {
                return false;
            }

            if(marker.properties.source == 'craft' && this.showCraftBranches)
            {
                // console.log(marker.properties.source, this.showCraftBranches, this.showApiBranches, this.showAtms);
                return true;
            }

            if(marker.properties.type == 'S' && this.showApiBranches && ((marker.properties.source == 'craft' && !this.showCraftBranches) == false))
            {
                // visible = true;
                return true;
            }

            if(marker.properties.type == 'A' && this.showAtms)
            {
                return true;
            }

            return false;
        },

        addressExists(location)
        {

            // console.log('testing')

            if(!location || location == null) {
                return false;
            }

            if(location.properties == null)
            {
                return false;
            }

            // console.log(location.properties.addressParts)

            if(location.properties.addressParts == null)
            {
                return false;
            }

            if(location.properties.addressParts.city == null)
            {
                return false;
            }

            if(location.properties.addressParts.stateAbbreviation == null)
            {
                return false;
            }

            if(location.properties.addressParts.zip == null)
            {
                return false;
            }


            return true;
        },


        /**
         * Add Markers
         * Method to add markers to the array. It strings the objects (to give them all consistent reference)
         * and adds them to a Set to keep them unique so we don't have duplicate markers
         */
        addMarkers( items ) {
            if ( ! Array.isArray( items ) ) {
                items = Object.values( items );
            }

            const tmp = [...this.unFiltered].concat( items );

            const uniqueArray = [...new Set( tmp.map( ( o ) => JSON.stringify( o ) ) )].map( ( s ) => JSON.parse( s ) );
            this.unFiltered = uniqueArray;

            // Populate the list of branches.
            this.branchesOnly = uniqueArray.filter( ( item ) => 'craft' === item.properties.source );
        },

        /**
         * Update the autocomplete list
         */
        updateList(event){
            //lets not search until there is something useful and have 3 characters
            if(event.target.value.length < 3){ this.list.length = 0; return}
            this.showSidebarBranches = false;
            // const dummyResults = [
            //     {
            //         placeId: 1,
            //         description: "7-Eleven Haverhill Street, Lawrence, MA"
            //     },
            //     {
            //         placeId: 1,
            //         description: "7-Eleven Lowel Street, Lawrence, MA"
            //     },
            //     {
            //         placeId: 1,
            //         description: "7-Eleven Beacon Street, Lawrence, MA"
            //     }
            // ];
            // this.list.length = 0;
            // dummyResults.forEach((prediction) => {
            //         this.list.push({
            //             placeId: prediction.place_id,
            //             description: prediction.description
            //         });
            // });

            // return;

            //Get autocomplete predictions back from google
            this.autocompleteService.getPlacePredictions({
                input: event.target.value,
                componentRestrictions: { country: 'US' }
            }, (predictions, status) => {

                if (status != google.maps.places.PlacesServiceStatus.OK) {
                    // console.log(status);
                    return;
                }
                //reset autocomplete list
                this.list.length = 0;

                //Add all the new predictions
                predictions.forEach( (prediction) => {
                    this.list.push({
                        placeId: prediction.place_id,
                        description: prediction.description
                    })
                });

            });
        },

        /**
         * When user chooses a location update search input's string
         * hide the autcomplete dropdown div
         * search that place ID
         */
        chooseLocation(placeId, description){
            this.searchString = description;
            this.autocompleteVisible = false;
            this.showSidebarBranches = false;
            this.searchByPlaceId(placeId);
        },

         /**
         * This is run to search google maps places to get place details
         */
        searchByPlaceId(placeId){
            let service = new google.maps.places.PlacesService(this.$refs.mapRef.map);
            var request = {
                placeId: placeId,
                fields: ['geometry']
            };
            service.getDetails(request, (place, status)=>{
                //update bounds and fit bounds to match the place result
                this.bounds = place.geometry.viewport;

                // console.log(`place.geometry.viewport`);
                // console.log(typeof place.geometry.viewport)
                // console.log(place.geometry.viewport)
                this.$refs.mapRef.map.fitBounds(place.geometry.viewport);
                this.$refs.mapRef.map.setZoom( 15 );
            });
        },

        openInfoWindow(id){
            //close the filter dropdown so it doesn't obscure an info window
            // this.filtersOpen = false;
            // this.showSidebarBranches = false;
            this.openedLocation = id;
            // console.log('openedLocation ID', id);

            //Get the details of this location
            let location = this.markers.find( (item)=>{
                return item.properties.id == id
            } );

            // console.log(location.properties.type != 'A');
            //Check if this is a branch, and if so open the branch panel, not an info window
            if( location.properties.slug != '') {
                // console.log(JSON.parse(JSON.stringify(location)))
                this.openBranchPane(location);
                return;
            }

            const instance = createApp(InfoContent, {
                    name: location.properties.name,
                    address: location.properties.addressParts,
                    directions: `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(location.properties.address)}`,
                    phone: location.properties.phone,
                    mapFeatures:location.properties.mapFeatures,
                    type: location.properties.type,
                    url: location.properties.slug,
                    apiSource: location.properties.source
            });
            const el = document.createElement('div');
            // el.dataset.apiSource = location.properties.source;

            const mountedInfoContent = instance.mount(el)

            //get the data that we'll pass to the google maps info window ready
            let contentString = mountedInfoContent.$el;

            //if there is already an info window close it.
            this.activeInfoWindow && this.activeInfoWindow.close();
            this.activeInfoWindow = new google.maps.InfoWindow({
                content: contentString,
                position: {lat: location.geometry.coordinates[1], lng: location.geometry.coordinates[0]}
            });

            this.activeInfoWindow.open(this.$refs.mapRef.map);
        },


        /**
         * on Idle fires from the map after the map is ready
         * we just hook into this to setup the autocomplete
         * since we know the maps service is ready
         */
        onIdle(){
            if(!this.autocompleteService){
                this.autocompleteService = new google.maps.places.AutocompleteService()
            }
            // console.log('autocomplete',this.autocompleteService);
            this.atmMarkerSize = new google.maps.Size(18, 23);
            this.branchMarkerSize = new google.maps.Size(18, 23);
            this.markerLabelPos = new google.maps.Point(63, 13);
        },

        /**
         * close the filters and info window on all map clicks
         */
        onMapClick(event){
            // console.log(event, this.activeInfoWindow);
            this.activeInfoWindow && this.activeInfoWindow.close();
            this.filtersOpen = false;
            this.showSidebarBranches = false;
        },

        /**
         * hide the autocomplete dropdown on blur of the search input
         * its put in a timeout so that it doesn't hide before the click
         * event listeners fire incase the blur is activated by a user
         * clicking a location.
         */
        blurAutocomplete(event){
            event.target.value = '';
            this.searchString = '';
            setTimeout(()=>this.autocompleteVisible = 0, 300);
        },

        /**
         * Get user's html5 geolocation
         */
        getUserLocation(){
            this.showLoading = true;

            navigator.geolocation.getCurrentPosition((position)=>{
                this.showLoading = false;

                //We'll draw a circle on the map to indicate where
                //the user is and use the geolocation accuracy to
                //define its radius.
                let locAccuracyCircle = new google.maps.Circle({
                    map: this.$refs.mapRef.map,
                    center: {
                        lat:position.coords.latitude,
                        lng:position.coords.longitude
                    },
                    radius: position.coords.accuracy,
                    strokeColor: '#d01f2f',
                    strokeOpacity: 0.3,
                    strokeWeight: 2,
                    fillColor: '#d01f2f',
                    fillOpacity: 0.15,
                });
                //Fit the map bounds to the circle
                this.$refs.mapRef.map.fitBounds(locAccuracyCircle.getBounds());

            }, (error)=>{
                //On errors show and hide (after a delay) an error message
                console.error(error);

                this.showLoading = true;
                this.locationErrorMessage = error.message;
                this.locationErrorShow = true;
                setTimeout(()=>{
                    this.locationErrorShow = false;
                }, 2000);
            });
        },

        openBranchPane(location){
            // console.log('openBranchPane()', location, location.properties.slug);
            this.branchSlug = location.properties.slug;
            this.showBranchPane = true;
            this.center.lat = location.geometry.coordinates[1];
            this.center.lng = location.geometry.coordinates[0];
            this.showSidebarBranches = false;
        },
    }
}
